import React, {Component} from 'react'
import {Button, Form, Row, Col, Table, Select, Spin, Input, DatePicker, Popover, Collapse, Tag, Modal, Tooltip, Image, InputNumber, Icon} from 'antd'
import alertMessage from '../../utils/alertMessage'
import {
  DownloadOutlined,
  ArrowsAltOutlined,
  DownOutlined,
  UpOutlined,
  QuestionCircleFilled,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  LockOutlined,
  UnlockOutlined
} from '@ant-design/icons'
import {getPaginationConfig} from '../../components/pagination'
import FormModal from './components/FormModal'
import FormModalReport from './components/FormModalReport'
import SearchDataModal from './components/SearchDataModal'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import {withRouter} from 'react-router-dom'
import moment from 'moment'
import {toJS} from 'mobx'
import PopTable from './components/PopTable'
import OutsideClickHandler from './components/OutsideClickHandler'
import history from '../../routes/history'
import FilterIcon from '../../components/icon/FilterIcon'
import RefreshIcon from '../../components/icon/RefreshIcon'
import SaveIcon from '../../components/icon/SaveIcon'
import DownloadIcon from '../../components/icon/DownloadIcon'
import EqualizerIcon from '../../components/icon/EqualizerIcon'

const storage = window.localStorage
const {confirm} = Modal
const {Panel} = Collapse
const customLocale = {
  emptyText: <span>数据更新中或暂无数据</span>
}

@inject('reportManagementStore', 'accountStore', 'routerStateModel', 'auditLogsStore')
@observer
class reportPage extends Component {
  formRef = React.createRef()
  iframeRef = React.createRef()
  formRefReport = React.createRef()
  tabsManagerRef = React.createRef()
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    modalVisible: false,
    searchModalVisible: false,
    tableData: [],
    selectLoading: false,
    selectOptions: {},
    generateParams: {},
    dynamicData: [],
    selectedRowKeys: [],
    popTableData: [],
    popTableLoading: false,
    popOpen: false,
    reportType: '查询语句',
    pbiUrl: '',
    maskRenderKey: null,
    updateTime: '',
    reportDescription: '',
    isFullScreen: false,
    canDownload: null,
    searchSort: null,
    sortList: [],
    selectorActiveKey: ['1'],
    anyNum: null,
    reportStatus: null,
    recordReportId: null,
    popupId: new Date().getTime()
  }
  transformSearchObject = obj => {
    const {reportManagementStore} = this.props
    const {reportPageCondition} = reportManagementStore
    const disposeData = {}
    const result = [...toJS(reportPageCondition)]

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (!disposeData[key]) {
          disposeData[key] = ''
        }
        const value = obj[key]
        if (moment.isMoment(value)) {
          disposeData[key] = value.format('YYYY-MM-DD HH:mm:ss')
        } else {
          if (value) {
            disposeData[key] = value
          }
        }
      }
    }

    for (const key in disposeData) {
      if (obj.hasOwnProperty(key)) {
        const parts = key.split('---')
        const middleType = parts[1]
        const index = Number(parts[parts.length - 1])

        // 确保 result[index].value 是一个数组
        if (typeof result[index].value === 'string') {
          try {
            result[index].value = JSON.parse(result[index].value)
          } catch {
            result[index].value = []
          }
        }
        if (!Array.isArray(result[index].value)) {
          result[index].value = []
        }

        if (middleType.includes('start1716367549959')) {
          result[index].value[0] = disposeData[key] // 设置起始时间
        } else if (middleType.includes('end1716367549959')) {
          result[index].value[1] = disposeData[key] // 设置结束时间
        } else {
          result[index].value = disposeData[key] // 单值字段
        }
      }
    }

    result.forEach(item => {
      if (typeof item.value === 'string') {
        item.value = item.value // 保留字符串
      } else if (Array.isArray(item.value)) {
        item.value = item.value.every(subItem => subItem === '') ? JSON.stringify([]) : JSON.stringify(item.value) // 转为字符串
      } else {
        item.value = JSON.stringify(item.value) // 转为字符串
      }
      delete item.placeholder // 删除多余的 placeholder
    })

    return result
  }

  processConditions = data => {
    return data.map(item => {
      if (item.type === 'DATE' && item.operator !== 'between') {
        item.value = item.value ? moment(item.value).format('YYYY-MM-DD') : ''
      } else if (item.type === 'DATE' && item.operator === 'between') {
        item.value = item.value ? JSON.stringify(JSON.parse(item.value).map(subItem => subItem !== '' ? moment(subItem).format('YYYY-MM-DD') : '')) : JSON.stringify([])
      }
      return item
    })
  }

  handleSearch = (pageNumber, pageSize, sortStr) => {
    const {reportManagementStore, reportName, auditLogsStore, match} = this.props
    const {page, size, searchSort} = this.state
    
    // 优先从URL参数获取reportId
    let reportId = null;
    if (match && match.params && match.params.id) {
      reportId = match.params.id;
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem');
      if (selectedItem) {
        reportId = selectedItem.split(',')[0];
      }
    }
    
    this.formRef.current.validateFields().then(fieldsValue => {
      const finalConditions = this.processConditions(this.transformSearchObject(fieldsValue))

      const logBody = finalConditions
        .filter(condition => condition.value && condition.value.trim() !== '' && condition.value.trim() !== '[]') // 剔除空值和仅包含空格的 value
        .map(condition => {
          // 处理 value 的格式
          let value = condition.value
          if (value.startsWith('[') && value.endsWith(']')) {
            value = value.slice(1, -1) // 去掉方括号
          }
          return `${condition.name}：${value}`
        })
      let params = {
        conditions: finalConditions,
        pageNo: pageNumber ? pageNumber : page,
        pageSize: pageSize ? pageSize : size,
        reportId: reportId,
        sortStr: sortStr || searchSort
      }
      this.setState({
        generateParams: {
          conditions: finalConditions,
          reportId: reportId
        }
      })
      reportManagementStore.getReportPage(params).then(res => {
        if (res?.code === 0) {
          let dynamicData = []
          if (res.data?.list.length > 0) {
            dynamicData = Object.keys(res.data?.list[0]).map(key => ({
              title: key,
              dataIndex: key,
              key
            }))
          }

          this.setState({
            tableData: res.data?.list,
            page: pageNumber ? pageNumber : page, // 当前页
            size: pageSize ? pageSize : size, // 每页显示条数
            total: res.data?.total, // 总条数,
            updateTime: res.data?.updateTime || '',
            dynamicData: dynamicData,
          })

          const params = {
            logUrl: '/api/v1/report/detail/page',
            logOperationType: '查询',
            logType: reportName + ':数据报表查询',
            logBody: String(logBody),

          }

          auditLogsStore.insertAuditLog(params)
        }
      })
    }).catch()
  }

  filterSave = () => {
    const {t, reportManagementStore, reportId} = this.props

    let inputValue = '' // 临时存储输入值

    confirm({
      title: t(`general.save`),
      icon: <QuestionCircleFilled/>,
      content: (
        <div>
          <p>{t(`general.saveTips`)}</p>
          <Input
            id="saveTitleInput" // 为输入框设置唯一ID
            placeholder={t('general.pleaseEnterTitle')}
            autocomplete="off"
          />
        </div>
      ),
      okText: t(`general.save`),
      cancelText: t(`general.cancel`),
      onOk: () => {
        // 在点击确定时获取输入框的值
        const inputElement = document.getElementById('saveTitleInput')
        inputValue = inputElement ? inputElement.value.trim() : ''

        if (!inputValue) {
          alertMessage.error(t('general.pleaseEnterTitle')) // 提示标题必填
          return Promise.reject() // 阻止对话框关闭
        }

        // 验证表单字段并执行保存操作
        return this.formRef.current.validateFields().then((fieldsValue) => {
          const finalConditions = this.processConditions(this.transformSearchObject(fieldsValue))
          let params = {
            conditions: finalConditions,
            reportId: reportId,
            title: inputValue, // 使用输入的标题
          }
          this.setState({
            generateParams: params,
          })
          return reportManagementStore.saveReportSearchData(params)
        }).catch((error) => {
          console.error('Validation failed:', error)
        })
      },
      onCancel: () => {
        console.log('Cancel')
      },
    })
  }

  handleExport = () => {
    this.setState({modalVisible: true})
  }

  handleSearchData = () => {
    this.setState({searchModalVisible: true})
  }


  handleCancel = target => {
    this.setState({
      [target]: false,
    })
  }
  handleUseSearch = target => {
    const {reportManagementStore} = this.props
    const {reportPageCondition} = reportManagementStore

    const conditionNull = reportPageCondition.map(item => ({
      ...item,
      value: null,
    }))

    reportManagementStore.setReportPageCondition(conditionNull).then(() => {
      // 重置表单
      this.formRef.current.resetFields()
      this.setState({
        [target]: false,
      })

      // 回填搜索条件
      const tempArr = [...toJS(reportPageCondition)]
      tempArr.forEach((item, index) => {
        let value
        try {
          value = JSON.parse(item.value)
        } catch (e) {
          console.warn(`Failed to parse JSON for item.value: ${item.value}`, e)
          value = item.value // 如果解析失败，使用原始值
        }

        // 如果是日期范围（数组），处理起始和结束值
        if (Array.isArray(value) && value.length === 2) {
          const startKey = item.name + '---start1716367549959---' + index
          const endKey = item.name + '---end1716367549959---' + index
          this.formRef.current.setFieldsValue({
            [startKey]: value[0] ? moment(value[0], 'YYYY-MM-DD HH:mm:ss') : undefined,
            [endKey]: value[1] ? moment(value[1], 'YYYY-MM-DD HH:mm:ss') : undefined,
          })
        }
        // 处理单个日期值
        else if (moment.isMoment(value)) {
          this.formRef.current.setFieldsValue({
            [item.name + '---' + index]: value,
          })
        }
        // 其他值（如字符串或普通数组）
        else if (value !== undefined && value !== null) {
          this.formRef.current.setFieldsValue({
            [item.name + '---' + index]: value,
          })
        }
      })

      // 执行后续操作
      this.handleSearch(1, 10)
      this.getPopTableData()
    })
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  getOptions = (open, name) => {
    const {reportManagementStore, reportId, match} = this.props
    const searchParams = this.formRef.current.getFieldsValue()
    const finalConditions = this.processConditions(this.transformSearchObject(searchParams))

    // 优先从URL参数获取reportId
    let currentReportId = reportId;
    if (match && match.params && match.params.id) {
      currentReportId = match.params.id;
    }

    if (open) {
      this.setState({selectLoading: true})
      reportManagementStore.getInSearchList({
        reportId: currentReportId,
        conditionName: name,
        conditions: finalConditions,
      }).then(res => {
        if (res?.code === 0) {
          this.setState({selectOptions: {...this.state.selectOptions, [name]: res.data.map(item => ({label: item, value: item}))}})
        }
        this.setState({selectLoading: false})
      }).catch(() => this.setState({selectLoading: false}))
    }
  }

  renderSearchCriteria = () => {
    const {reportManagementStore} = this.props
    const {reportPageCondition} = reportManagementStore
    const {selectOptions, selectLoading} = this.state
    let searchButtons = false
    const finalArray = reportManagementStore.reportPageCondition?.map((item, index) => {
      if (index === 15) searchButtons = true

      const commonProps = {
        key: item.name + '---' + index,
        label: item.name,
        initialValue: item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined, // 设置默认值，为空时不填充
        labelCol: {
          xs: 24, sm: 11, md: 11, lg: 11, xl: 11, xxl: 8, span: 8,
        },
      }

      // 1. DATETIME 或 TIMESTAMP 且操作符为 between
      if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP') && item.operator === 'between') {
        let startValue = undefined
        let endValue = undefined

        if (typeof item.value === 'string' && item.value.trim().startsWith('[') && item.value.trim().endsWith(']')) {
          try {
            const parsedValue = JSON.parse(item.value)
            startValue = parsedValue[0] ? moment(parsedValue[0], 'YYYY-MM-DD HH:mm:ss') : undefined
            endValue = parsedValue[1] ? moment(parsedValue[1], 'YYYY-MM-DD HH:mm:ss') : undefined
          } catch (error) {
            console.error('Error parsing datetime value:', error)
          }
        }

        return (
          <>
            <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---start1716367549959---' + index}>
              <Form.Item
                {...commonProps}
                name={item.name + '---start1716367549959---' + index}
                label={item.name + ' 起始'}
                initialValue={startValue}
              >
                <DatePicker style={{width: '100%'}} placeholder={item.placeholder} showTime/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---end1716367549959---' + index}>
              <Form.Item
                {...commonProps}
                name={item.name + '---end1716367549959---' + index}
                label={item.name + ' 结束'}
                initialValue={endValue}
              >
                <DatePicker style={{width: '100%'}} placeholder={item.placeholder} showTime/>
              </Form.Item>
            </Col>
          </>
        )
      }

      if (item.type !== 'DATETIME' && item.type !== 'TIMESTAMP' && item.type !== 'DATE' && item.operator === 'between') {
        if (index === 15) searchButtons = true
        return <>
          <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---start1716367549959---' + index}>
            <Form.Item
              {...commonProps}
              name={item.name + '---start1716367549959---' + index}
              label={item.name + ' 起始'}
              initialValue={item.value?.start !== undefined && item.value?.start !== null && item.value?.start !== '' ? item.value?.start : undefined} // 设置起始默认值，为空时不填充
            >
              <Input placeholder={item.placeholder} allowClear/>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---end1716367549959---' + index}>
            <Form.Item
              {...commonProps}
              name={item.name + '---end1716367549959---' + index}
              label={item.name + ' 结束'}
              initialValue={item.value?.end !== undefined && item.value?.end !== null && item.value?.end !== '' ? item.value?.end : undefined} // 设置结束默认值，为空时不填充
            >
              <Input placeholder={item.placeholder} allowClear/>
            </Form.Item>
          </Col>
        </>
      }

      if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP' || item.type === 'DATE') && item.operator !== 'between' && item.operator === 'in') {
        let initialValue = []

        if (typeof item.value === 'string' && item.value.trim().startsWith('[') && item.value.trim().endsWith(']')) {
          try {
            const parsedValue = JSON.parse(item.value)
            initialValue = Array.isArray(parsedValue)
              ? parsedValue.map((val) => moment(val, 'YYYY-MM-DD HH:mm:ss'))
              : []
          } catch (e) {
            console.error('Failed to parse item.value as JSON:', e)
          }
        } else if (Array.isArray(item.value)) {
          initialValue = item.value.map((val) => moment(val, 'YYYY-MM-DD HH:mm:ss'))
        }

        return (
          <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
            <Form.Item {...commonProps} name={item.name + '---' + index} initialValue={initialValue}>
              <Select
                placeholder={item.placeholder}
                allowClear
                mode="multiple"
                showArrow
                onDropdownVisibleChange={(open) => this.getOptions(open, item.name)}
                options={selectOptions[item.name]}
                loading={selectLoading}
              />
            </Form.Item>
          </Col>
        )
      }

      if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP') && item.operator !== 'between' && item.operator !== 'in') {
        return (
          <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
            <Form.Item
              {...commonProps}
              name={item.name + '---' + index}
              initialValue={item.value ? moment(item.value, 'YYYY-MM-DD HH:mm:ss') : undefined}
            >
              <DatePicker style={{width: '100%'}} showTime/>
            </Form.Item>
          </Col>
        )
      }


      if (item.type !== 'DATETIME' && item.type !== 'TIMESTAMP' && item.type !== 'DATE' && item.operator !== 'between' && item.operator === 'in') {
        let initialValue = []

        if (typeof item.value === 'string' && item.value.trim().startsWith('[') && item.value.trim().endsWith(']')) {
          try {

            const parsedValue = JSON.parse(item.value)
            initialValue = Array.isArray(parsedValue) ? parsedValue : [parsedValue]
          } catch (e) {
            console.error('Failed to parse item.value as JSON:', e)
            initialValue = item.value ? [item.value] : []
          }
        } else if (Array.isArray(item.value)) {
          initialValue = item.value
        } else {
          initialValue = item.value ? [item.value] : []
        }

        return <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
          <Form.Item
            {...commonProps}
            name={item.name + '---' + index}
            initialValue={initialValue} // 设置默认值，为空时不填充
          >
            <Select
              placeholder={item.placeholder}
              allowClear
              mode="multiple"
              showArrow
              maxTagCount="responsive"
              onDropdownVisibleChange={open => this.getOptions(open, item.name)}
              options={selectOptions[item.name]}
              loading={selectLoading}
              autoClearSearchValue={false}
            />
          </Form.Item>
        </Col>
      }
      // 2. DATE 且操作符为 between
      if (item.type === 'DATE' && item.operator === 'between') {
        if (index === 15) searchButtons = true
        return (
          <>
            <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---start1716367549959---' + index}>
              <Form.Item
                {...commonProps}
                name={item.name + '---start1716367549959---' + index}
                label={item.name + ' 起始'}
                initialValue={item.value?.start || undefined}
              >
                <DatePicker style={{width: '100%'}} placeholder={item.placeholder}/>
              </Form.Item>
            </Col>
            <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---end1716367549959---' + index}>
              <Form.Item
                {...commonProps}
                name={item.name + '---end1716367549959---' + index}
                label={item.name + ' 结束'}
                initialValue={item.value?.end || undefined}
              >
                <DatePicker style={{width: '100%'}} placeholder={item.placeholder}/>
              </Form.Item>
            </Col>
          </>
        )
      }

      if (item.type === 'DATE' && item.operator !== 'between' && item.operator !== 'in') {
        return <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
          <Form.Item
            {...commonProps}
            name={item.name + '---' + index}
            initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
          >
            <DatePicker style={{width: '100%'}}/>
          </Form.Item>
        </Col>
      }

      // 4. DATETIME、TIMESTAMP 或 DATE 且操作符为 single
      if ((item.type === 'DATETIME' || item.type === 'TIMESTAMP' || item.type === 'DATE') && item.operator === 'single') {
        return (
          <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
            <Form.Item
              {...commonProps}
              name={item.name + '---' + index}
              initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined}
            >
              <Select
                placeholder={item.placeholder}
                allowClear
                showArrow
                onDropdownVisibleChange={(open) => this.getOptions(open, item.name)}
                options={selectOptions[item.name]}
                loading={selectLoading}
              />
            </Form.Item>
          </Col>
        )
      }

      if (item.type !== 'DATETIME' && item.type !== 'TIMESTAMP' && item.type !== 'DATE' && item.operator !== 'between' && item.operator === 'single') {
        return <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
          <Form.Item
            {...commonProps}
            name={item.name + '---' + index}
            initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
          >
            <Select
              placeholder={item.placeholder}
              allowClear
              showArrow
              maxTagCount="responsive"
              onDropdownVisibleChange={open => this.getOptions(open, item.name)}
              options={selectOptions[item.name]}
              loading={selectLoading}
            />
          </Form.Item>
        </Col>
      }

      if (item.type === 'DATE' && item.operator !== 'between' && item.operator !== 'single') {
        return <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
          <Form.Item
            {...commonProps}
            name={item.name + '---' + index}
            initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
          >
            <DatePicker style={{width: '100%'}}/>
          </Form.Item>
        </Col>
      }

      if (item.operator === 'likes') {

        return <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
          <Form.Item
            {...commonProps}
            name={item.name + '---' + index}
            initialValue={item.value && item.value !== undefined && item.value !== null && item.value !== '' ? JSON.parse(item.value) || [] : []}
          >
            <Select
              className='select-tag-style'
              mode="tags"
              placeholder={item.placeholder}
              allowClear
              open={false}
              style={{width: '100%'}}
              options={[]}
            />
          </Form.Item>
        </Col>
      }

      return <Col xs={24} sm={8} md={8} lg={8} xl={6} xxl={6} span={6} key={item.name + '---' + index}>
        <Form.Item
          {...commonProps}
          name={item.name + '---' + index}
          initialValue={item.value !== undefined && item.value !== null && item.value !== '' ? item.value : undefined} // 设置默认值，为空时不填充
        >
          <Input placeholder={item.placeholder} allowClear/>
        </Form.Item>
      </Col>
    })

    return {finalArray, searchButtons}
  }

  onOpenChange = value => {
    this.setState({popOpen: value})
  }

  getPopTableData = () => {
    const {reportManagementStore, match} = this.props
    
    // 优先从URL参数获取reportId
    let reportId = null;
    if (match && match.params && match.params.id) {
      reportId = match.params.id;
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem');
      if (selectedItem) {
        reportId = selectedItem.split(',')[0];
      }
    }
    
    reportManagementStore.getReportConfig(reportId).then(res => {
      if (res?.code === 0) {
        this.setState({
          popTableData: res.data.map(item => ({key: item.name, ...item})) || [],
          popTableLoading: false
        })
      }
    }).catch(() => {
      this.setState({popTableLoading: false})
    })
  }

  getReportConfig = () => {
    this.onOpenChange(true)
    this.setState({popTableLoading: true})
    this.getPopTableData()
  }

  handleFullScreen = () => {
    const iframeWrap = this.iframeRef.current

    if (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement) {
      // 如果当前处于全屏状态，则退出全屏
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { // Firefox
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { // IE/Edge
        document.msExitFullscreen()
      }
      this.setState({isFullScreen: false})
    } else {
      // 如果当前不处于全屏状态，则进入全屏
      if (iframeWrap.requestFullscreen) {
        iframeWrap.requestFullscreen()
      } else if (iframeWrap.mozRequestFullScreen) { // Firefox
        iframeWrap.mozRequestFullScreen()
      } else if (iframeWrap.webkitRequestFullscreen) { // Chrome, Safari and Opera
        iframeWrap.webkitRequestFullscreen()
      } else if (iframeWrap.msRequestFullscreen) { // IE/Edge
        iframeWrap.msRequestFullscreen()
      }
      this.setState({isFullScreen: true})
    }
  }

  onSort = (pagination, filters, sorter) => {
    const {current, pageSize} = pagination
    const sortList = Array.isArray(sorter) ? sorter.filter(item => item.order) : (sorter.order ? [sorter] : [])
    const sortString = sortList.length > 0 ? sortList.map(item => `'${item.field}' ${item.order === 'ascend' ? 'asc' : 'desc'}`).join(',') : null
    this.setState({searchSort: sortString, sortList: sortList}, () => {
      this.handleSearch(current, pageSize, sortString)
    })
  }

  handleReset = () => {
    const {reportManagementStore} = this.props
    const {reportPageCondition} = reportManagementStore

    const conditionNull = reportPageCondition.map(item => ({
      ...item,
      value: null
    }))

    reportManagementStore.setReportPageCondition(conditionNull).then(() => {
      this.formRef.current.resetFields()
    })
  }

  toggleSelector = () => {
    const {selectorActiveKey} = this.state
    if (selectorActiveKey.includes('2')) {
      this.setState({selectorActiveKey: ['1']})
    } else {
      this.setState({selectorActiveKey: ['1', '2']})
    }
  }

  componentDidMount() {
    const {reportManagementStore, accountStore, type, match} = this.props
    const {isTabHas} = accountStore
    
    // 优先从URL参数获取reportId
    let reportId = null;
    if (match && match.params && match.params.id) {
      reportId = match.params.id;
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem');
      if (selectedItem) {
        reportId = selectedItem.split(',')[0];
      }
    }
    
    if (!isTabHas) {
      // if (reportId && reportId !== 'reportPage' && reportId !== 'pbiReportPage') {
      if (type !== 'reportManagement') {
        reportManagementStore.getReportDetail(reportId).then((e) => {
          const {data} = e
          if (data?.type === '查询语句') {
            this.handleSearch(1, 10)
            this.getPopTableData()
          }
          this.setState({
            reportType: data?.type,
            pbiUrl: data?.pbiUrl,
            reportDescription: data?.reportDescription,
            canDownload: data?.canDownload
          })
        })
      } else {
        reportManagementStore.getReportRoles()
        reportManagementStore.getReportConditions()
        this.handleSearchReport(1, 10)
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {accountStore, reportManagementStore, routerStateModel, type, match} = this.props
    const {currentUrl, urlHistory} = routerStateModel
    const {isTabHas} = accountStore
    const tips = true
    
    // 优先从URL参数获取reportId
    let reportId = null;
    if (match && match.params && match.params.id) {
      reportId = match.params.id;
    } else {
      // 向后兼容：从localStorage获取
      const selectedItem = localStorage.getItem('selectedItem');
      if (selectedItem) {
        reportId = selectedItem.split(',')[0];
      }
    }
    
    // 判断该菜单是否已经存在于标签中。
    const isTab = urlHistory?.filter(a => a?.id.toString() === reportId)?.length > 0 ? false : true
    if (!isTab) {
      if (currentUrl.groupKey !== prevProps.routerStateModel.currentUrl.groupKey && type !== 'reportManagement') {
        reportManagementStore.getReportDetail(reportId).then((e) => {
          const {data} = e
          this.setState({
            reportType: data?.type,
            pbiUrl: data?.pbiUrl,
            reportDescription: data?.reportDescription,
            canDownload: data?.canDownload,
            searchSort: null,
            sortList: [],
            selectorActiveKey: ['1']
          })
          if (data?.type !== '查询语句') return
          this.formRef.current.resetFields()
          this.handleSearch(1, 10)
          this.getPopTableData()
        })
      }
    }
  }

  componentWillUnmount() {
    const { match } = this.props;
    
    // 优先从URL参数判断
    if (!match || !match.params || !match.params.id) {
      // 如果没有URL参数，则检查localStorage
      if (!localStorage.getItem('selectedItem')) {
        history.push('/')
      }
    }
  }


  //reportManagement页面
  handleDelete = record => {
    const {t, reportManagementStore, auditLogsStore} = this.props
    let _this = this

    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportManagementStore.deleteReport(record.id).then(() => {
          _this.callTabsManagerMethod(record.id)
          const params = {
            logUrl: '/api/v1/report/del',
            logType: '删除报表:' + record.reportName,
            logOperationType: '删除'
          }

          auditLogsStore.insertAuditLog(params)


          _this.handleSearchReport()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }
  callTabsManagerMethod = (id) => {
    if (this.tabsManagerRef.current) {
      this.tabsManagerRef.current.removeTargetKey(id)
    }
  }

  handleSearchReport = (pageNumber, pageSize) => {
    const {reportManagementStore, auditLogsStore} = this.props
    const {page, size} = this.state

    this.formRefReport.current.validateFields().then(fieldsValue => {
      let params = {
        ...fieldsValue,
        pageNo: pageNumber ? pageNumber : page,
        pageSize: pageSize ? pageSize : size,
      }

      reportManagementStore.getReportList(params).then(res => {
        if (res?.code === 0) {
          // this.setState({
          //   tableData: res?.data?.list,
          //   page: pageNumber ? pageNumber : page, // 当前页
          //   size: pageSize ? pageSize : size, // 每页显示条数
          //   total: res?.data?.total // 总条数
          // })
          reportManagementStore.onChangeTableData({
            tableData: res?.data?.list,
            page: pageNumber ? pageNumber : page, // 当前页
            size: pageSize ? pageSize : size, // 每页显示条数
            total: res?.data?.total // 总条数
          })
          const params = {
            logUrl: '/api/v1/report/page',
            logType: '报表管理查询',
            logOperationType: '查询'
          }

          auditLogsStore.insertAuditLog(params)
        }
      })
    }).catch()
  }

  handleCreate = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleCancelReport = target => {
    this.setState({
      [target]: false,
      recordReportId: null
    })
  }

  handleEdit = (record) => {
    this.setState({
      modalVisible: true,
      recordReportId: record?.id,
      reportStatus: record?.status
    })
  }

  handleSetStatus = record => {
    const {t, reportManagementStore} = this.props
    const {id, status} = record
    let _this = this

    confirm({
      title: status ? t(`general.lockReport`) : t(`general.unlockReport`),
      icon: <QuestionCircleFilled/>,
      content: status ? t(`general.sureToLock`) : t(`general.sureToUnLock`),
      okText: status ? t(`general.lock`) : t(`general.unlock`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportManagementStore.setReportStatus(id, !status).then(() => {
          if (!record.state) {
            _this.callTabsManagerMethod(record.id)
          }
          _this.handleSearchReport()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  changeReportSort = (e, id) => {
    const {reportManagementStore} = this.props
    reportManagementStore.saveReportSort(id, e.target.value).then(() => {
      this.handleSearchReport()
      reportManagementStore.onSortChange()
    })
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {t, reportManagementStore, accountStore, reportName, reportId, key, location, type} = this.props
    const {reportRoleList, isFetching, reportTableData, reportPageCondition} = reportManagementStore
    const {reportFetchFlag} = accountStore
    const {
      page,
      size,
      total,
      tableData,
      modalVisible,
      searchModalVisible,
      generateParams,
      dynamicData,
      popTableData,
      popTableLoading,
      popOpen,
      reportType,
      pbiUrl,
      isFullScreen,
      canDownload,
      sortList,
      selectorActiveKey,
      reportStatus,
      recordReportId
    } = this.state
    const pagination = getPaginationConfig(page, size, total, this.handleSearch)
    const paginationReport = getPaginationConfig(reportTableData.page, reportTableData.size, reportTableData.total, this.handleSearchReport)
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      labelWrap: true,
      colon: false
    };
    return (
      <Spin spinning={isFetching}>
        {type === 'reportManagement' ?
          <div className="container">
            <Form ref={this.formRefReport} size="middle" className="searchForm" labelWrap={false} layout={themeStyle?.layoutHorizontal ? "horizontal" : "vertical"} onValuesChange={this.onValuesChange}>
              {/* <div className="searchFormTitle">
                <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
              </div> */}
              <Row gutter={[10, 0]}>
                <Col span={6}>
                  <Form.Item name="reportName" label={t(`reportManagement.reportName`)}>
                    <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="type" label={t(`reportManagement.reportType`)}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                      <Select.Option key={0} value={'查询语句'}>查询语句</Select.Option>
                      <Select.Option key={1} value={'PowerBI'}>PowerBI</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="roles" label={t(`reportManagement.role`)}>
                    <Select
                      placeholder={t(`general.pleaseSelect`)}
                      allowClear mode="multiple"
                      showArrow
                      maxTagCount="responsive"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {
                        reportRoleList.length > 0
                          ? reportRoleList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)
                          : null
                      }
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name="status" label={t(`reportManagement.status`)} initialValue={true}>
                    <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                      <Select.Option key={true} value={true}>启用</Select.Option>
                      <Select.Option key={false} value={false}>停用</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{textAlign: 'right', marginTop: 20, marginBottom: 10}}>
                  <Button onClick={() => { this.handleSearchReport(1, 10) }} className="ant-btn-red">{t(`general.search`)}</Button>
                  <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
                </Col>
              </Row>
            </Form>

            <Table className="searchResult" dataSource={reportTableData.tableData} rowKey="id" pagination={paginationReport}
                   rowClassName={this.getRowClassName}>
              <Table.Column align="center" width={80} fixed="left" title={t(`reportManagement.status`)} dataIndex="status" key="status"
                            render={text => <div style={{
                              display: 'inline-block',
                              height: 24,
                              width: 24,
                              lineHeight: '24px',
                              fontSize: 12,
                              borderRadius: 24,
                              color: 'white',
                              textAlign: 'center',
                              background: text ? themeStyle?.statusColor?.split(',')?.[0] || '#97cf7c' : themeStyle?.statusColor?.split(',')?.[1] || '#ef6e6e'
                            }} title={text ? '启用' : '停用'}>{text ? '启' : '停'}</div>}
              />
              <Table.Column title={t(`reportManagement.reportName`)} dataIndex="reportName" key="reportName" ellipsis={true}/>
              <Table.Column title={t(`reportManagement.reportType`)} dataIndex="type" key="type" ellipsis={true}/>
              <Table.Column title={t(`reportManagement.createUser`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
              <Table.Column title={t(`reportManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
              <Table.Column title={t(`reportManagement.reportSort`)} dataIndex="reportSort" key="reportSort" render={(text, record) => {
                return (
                  <InputNumber value={record.reportSort} onBlur={(e) => this.changeReportSort(e, record.id)} precision={0} controls={false}/>
                )
              }}/>
              <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
                return (
                  <>
                    <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
                    <Button
                      type="link"
                      onClick={() => this.handleSetStatus(record)}
                      icon={record.status ? <UnlockOutlined/> : <LockOutlined/>}
                      title={record.status ? t(`reportManagement.enabled`) : t(`reportManagement.disabled`)
                      }
                    />
                    <Button type="link" onClick={() => this.handleDelete(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
                  </>
                )
              }}/>
            </Table>
            {
              modalVisible
                ? <FormModalReport
                  handleCancel={this.handleCancelReport}
                  handleSearch={this.handleSearchReport}
                  modalVisible={modalVisible}
                  reportId={recordReportId}
                  reportStatus={reportStatus}
                />
                : null
            }
          </div> :
          reportType === '查询语句' ?
            <div className="container report-container">
              <Form ref={this.formRef} size="middle" className="searchForm report-searchForm" layout={themeStyle?.layoutHorizontal ? "horizontal" : "vertical"} {...formItemLayout}>
                {/* <div className="searchFormTitle">
                  <div>
                   <SearchOutlined/> {reportMenus.filter(item => item.id === Number(localStorage.getItem('selectedItem').split(',')[0]))[0]?.name}
                  </div>
                  {
                    reportPageCondition?.length > 16
                    && <div className="toggle-selector" onClick={this.toggleSelector}>
                      <span>{selectorActiveKey.includes('2') ? '收起' : '展开'}筛选器</span>

                      {
                        selectorActiveKey.includes('2')
                          ? <UpOutlined/>
                          : <DownOutlined/>
                      }
                    </div>
                  }
                </div> */}
                <Collapse activeKey={reportPageCondition?.length > 4 ? selectorActiveKey : ['1', '2']} ghost bordered={false} collapsible="disabled" style={{marginTop: reportPageCondition?.length > 4 ? 0 : 10}}>
                  <Panel header="" key="1" forceRender>
                    <Row gutter={[10, 0]} className='btnIcon'>
                      {/* 加载所有表单，通过className控制隐藏 */}
                      {this.renderSearchCriteria()['finalArray']?.map((item, index) => (
                        <React.Fragment key={index}>
                          {React.cloneElement(item, {
                            className: index >= 4 && !selectorActiveKey.includes('2')
                              ? 'hidden-form-item'  // 前4个外且未展开时隐藏
                              : ''
                          })}
                        </React.Fragment>
                      ))}
                      <Col flex="auto" style={{
                          textAlign: 'right',
                          marginTop: reportPageCondition?.length > 0 ? 0 : -10,
                          marginBottom: reportPageCondition?.length > 0 ? 0 : 10
                        }}>
                          <Button onClick={this.handleReset} type="primary" icon={<RefreshIcon name='save-icon' color='#666666' />} className='bg-grey' title={t('general.reset')} />
                          {
                            reportPageCondition?.length > 0 && (
                              <>
                                <Button onClick={this.filterSave} type="primary" icon={<SaveIcon name='save-icon' color='#031a34' />} className='bg-blue' title={t('general.filterSave')} />
                                <Button onClick={this.handleSearchData} type="primary" icon={<EqualizerIcon name='save-icon' color='#031a34' />} className='bg-blue' title={t('general.searchData')} />
                              </>
                            )
                          }
                          <Button onClick={() => { this.handleSearch(1, 10) }} className="ant-btn-red">{t(`general.search`)}</Button>

                          {
                            canDownload
                              ? <Button onClick={this.handleExport} type="primary" icon={<DownloadIcon name='save-icon' color='#ffffff' />} title={t(`general.export`)} />
                              : null
                          }
                          <a style={{ fontSize: 12, marginLeft: 20 }}
                            onClick={this.toggleSelector}
                          >
                            {selectorActiveKey.includes('2') ? <UpOutlined /> : <DownOutlined />} {selectorActiveKey.includes('2') ? '收起' : '展开'}筛选器
                          </a>
                        </Col>
                    </Row>
                  </Panel>
                  {/* <Panel header="" key="2" forceRender>
                    <Row gutter={[10, 0]} className='btnIcon'>
                      {this.renderSearchCriteria()['finalArray']?.slice((this.renderSearchCriteria()['searchButtons'] && !selectorActiveKey.includes('2')) ? 15 : 4)}
                      {
                        selectorActiveKey.includes('2')
                        && <Col flex="auto" style={{
                          textAlign: 'right',
                          marginTop: reportPageCondition?.length > 0 ? 0 : -40,
                          marginBottom: reportPageCondition?.length > 0 ? 0 : 10
                        }}>
                          <Button onClick={this.handleReset} type="primary" icon={<RefreshIcon name='save-icon' color='#666666' />} className='bg-grey' title={t('general.reset')} />
                          {
                            reportPageCondition?.length > 0 && (
                              <>
                                <Button onClick={this.filterSave} type="primary" icon={<SaveIcon name='save-icon' color='#031a34' />} className='bg-blue' title={t('general.filterSave')} />
                                <Button onClick={this.handleSearchData} type="primary" icon={<EqualizerIcon name='save-icon' color='#031a34' />} className='bg-blue' title={t('general.searchData')} />
                              </>
                            )
                          }
                          <Button onClick={() => { this.handleSearch(1, 10) }}className="ant-btn-red">{t(`general.search`)}</Button>
                          {
                            canDownload
                              ? <Button onClick={this.handleExport} type="primary" icon={<DownloadOutlined/>}>{t(`general.export`)}</Button>
                              : null
                          }
                        </Col>
                      }
                    </Row>
                  </Panel> */}
                </Collapse>
              </Form>

              <div className="searchResult">
                <Row justify="end" gutter={[10, 0]}>
                  {
                    !!this.state.updateTime && (
                      <Col span={8} style={{fontSize: '14px'}}>
                        {t(`reportManagement.reportUpdateTime`)}：{this.state.updateTime}
                      </Col>
                    )
                  }
                  <Col span={16} flex="auto" style={{textAlign: 'right'}}>
                    <div className="report-column-sort">
                      <OutsideClickHandler onClickOutside={this.onOpenChange} instanceId={this.state.popupId}>
                        <Popover
                          placement="left"
                          getPopupContainer={() => document.querySelector(`.pop-warp-${this.state.popupId}`)}
                          content={
                            <PopTable
                              popTableData={popTableData}
                              popTableLoading={popTableLoading}
                              onSearch={this.handleSearch}
                              onOpenChange={this.onOpenChange}
                            />
                          }
                          title="列筛选排列"
                          visible={popOpen}
                          destroyTooltipOnHide={true}
                        >
                          <div onClick={this.getReportConfig} style={{ cursor: 'pointer', height: '32px', width: '32px'}}>
                            <FilterIcon name='filter-icon' color='#031a34' />
                          </div>



                          {/* <Button className="searchList" onClick={this.getReportConfig} style={{height: '32px', lineHeight: '22px', minWidth: '32px', padding: '4px 0', top: '-5px'}}>
                            列筛选排列
                          </Button> */}
                        </Popover>
                      </OutsideClickHandler>
                    </div>
                  </Col>
                </Row>
                <div style={{marginTop: '-20px', marginBottom: '10px'}}>
                  {
                    sortList.map(item => (
                      <Tag>{item.field} {item.order === 'ascend' ? '升序' : '降序'}</Tag>
                    ))
                  }
                </div>
                <Table
                  key={reportId}
                  dataSource={this.state.tableData}
                  pagination={pagination}
                  rowClassName={this.getRowClassName}
                  scroll={{x: 'max-content'}}
                  locale={customLocale}
                  onChange={this.onSort}
                  tableLayout="auto"
                  bordered
                >
                  {
                    this.state.tableData?.length > 0
                      ? dynamicData.map((item, index) => (
                        <Table.Column
                          title={item.title}
                          dataIndex={item.dataIndex}
                          key={item.dataIndex}
                          // ellipsis={true}
                          // width={180}
                          minWidth={20}
                          sorter={{
                            multiple: index,
                          }}
                          render={(text, record) => (
                            text && text?.toString()?.toLowerCase()?.includes('https://') && (text?.toString()?.toLowerCase()?.includes('.jpg') || text?.toString()?.toLowerCase()?.includes('.png') || text?.toString()?.toLowerCase()?.includes('.jpeg')) ?
                              <Image height={50} src={text} alt="" preview={{mask: ('View')}}/> :
                              text ?
                                <Tooltip placement="topLeft" title={text}>
                                  <div style={{
                                    minWidth: 20,
                                    maxWidth: 200,
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                  }}>{text}</div>
                                </Tooltip> :
                                text
                          )}
                        />
                      ))
                      : popTableData.map((item, index) => (
                        <Table.Column
                          title={item.name}
                          dataIndex={item.name}
                          key={item.name}
                          // ellipsis={true}
                          // width={180}
                          minWidth={20}
                          sorter={{
                            multiple: index,
                            sortOrder: sortList?.filter(sortItem => sortItem?.field === item.dataIndex).length > 0 ? sortList.filter(sortItem => sortItem?.field === 'item.dataIndex')[0]?.order : null
                          }}
                          render={(text, record) => (
                            text && text?.toString()?.toLowerCase()?.includes('https://') && (text?.toString()?.toLowerCase()?.includes('.jpg') || text?.toString()?.toLowerCase()?.includes('.png') || text?.toString()?.toLowerCase()?.includes('.jpeg')) ?
                              <Image height={50} src={text} alt="" preview={{mask: ('View')}}/> :
                              text ?
                                <Tooltip placement="topLeft" title={text}>
                                  <div style={{
                                    minWidth: 20,
                                    maxWidth: 200,
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                  }}>{text}</div>
                                </Tooltip> :
                                text
                          )}
                        />
                      ))
                  }
                </Table>
                {!!this.state.reportDescription && (
                  <Row style={{fontSize: '13px', whiteSpace: 'pre-wrap'}} gutter={[10, 0]}>
                    <Col>{t(`reportManagement.reportDes`)}:</Col>
                    <Col span={21}>{this.state.reportDescription}</Col>
                  </Row>)}
                <div style={{display: 'none'}}>{reportFetchFlag}</div>
              </div>

              {
                modalVisible
                  ? <FormModal
                    handleCancel={this.handleCancel}
                    modalVisible={modalVisible}
                    reportName={reportName}
                    reportId={reportId}
                    generateParams={generateParams}
                  />
                  : null
              }

              {
                searchModalVisible
                  ? <SearchDataModal
                    handleCancel={this.handleCancel}
                    handleUseSearch={this.handleUseSearch}
                    modalVisible={searchModalVisible}
                    reportName={reportName + ' 搜索筛选数据管理'}
                    reportId={reportId}
                    generateParams={generateParams}
                  />
                  : null
              }
            </div>
            : reportType !== '查询语句' ?
              <div className="container" ref={this.iframeRef}>
                <div className={pbiUrl.includes('https://iedw-bi.ciif-expo.com') ? 'button-task-blue' : 'button-task'}></div>
                <div className={pbiUrl.includes('https://iedw-bi.ciif-expo.com') ? 'right-task-blue' : 'right-task'}></div>
                <Button icon={<ArrowsAltOutlined/>}
                        className={pbiUrl.includes('https://iedw-bi.ciif-expo.com') ? 'iframe-fullscreen-button-blue' : 'iframe-fullscreen-button'}
                        onClick={this.handleFullScreen}></Button>
                <iframe className={isFullScreen ? 'iframe-fullscreen-style' : 'iframe-not-fullscreen-style'}
                        src={pbiUrl}></iframe>
              </div>
              : null
        }

      </Spin>
    )
  }
}

export default withRouter(withTranslation()(reportPage))
